import clsx from 'clsx';
import { InputHTMLAttributes, forwardRef, useId } from 'react';

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  validate?: {
    func: (value: string) => boolean;
    message: string;
  };
}

export const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, validate, ...props }, ref) => {
    const id = useId();
    const isValid = !props.value
      ? true
      : validate?.func ? validate.func(props.value as string) : true;
    const errorMessage = validate?.message;

    return (
      <div className="flex flex-col gap-2">
        {label && (
          <label
            htmlFor={props.id ?? id}
            className="font-medium text-sm leading-[1.0625rem] cursor-text"
          >
            {label}
          </label>
        )}
        <input
          type="text"
          className={clsx(
            "h-12 min-w-[9.0625rem] w-auto px-5 py-[0.96875rem] rounded-lg bg-white bg-opacity-10 outline-none",
            "font-medium text-sm leading-[1.0625rem] text-white",
            "border",
            isValid ? "border-transparent" : "border-red-500",
          )}
          ref={ref}
          id={props.id ?? id}
          {...props}
        />
        {!isValid && errorMessage && (
          <p className="text-red-500 text-xs">{errorMessage}</p>
        )}
      </div>
    );
  }
);
